import * as React from "react";
import { Modal } from "../../../Modal";
import * as main from '../styles/main.module.scss';
import * as process from '../styles/process.module.scss';

export const Process = () => {
  const [showModal, setShowModal] = React.useState(false);
  return (
    <section className={process.process}>
      <div className={`container ${process.process__container}`}>
        <div className={process.process__wrapper_left}>
          <h2 className={process.process__title}>Процесс обучения</h2>
          <img
            src="https://fs.advance.ru/landing-pages/online/angliyskiy_dlya_vashih_celey/_process/screencast_gif.gif"
            alt={''}
          />
          <button
            className={`${process.process__button} ${main.allBtn}`}
            onClick={() => {
              setShowModal(true);
            }}
          >
            Посмотреть полный обзор платформы
          </button>
        </div>
        <div>
          <ul>
            <li className={process.process__item}>Удобная онлайн-платформа с уникальными упражнениями</li>
            <li className={process.process__item}>Техническая и образовательная поддержка 24/7</li>
            <li className={process.process__item}>Индивидуальная настройка сложности и скорости</li>
            <li className={process.process__item}>
              Отработка чтения, грамматики, лексики, аудирования и говорения на каждом уроке
            </li>
            <li className={process.process__item}>Чат с кураторами и сообщество с другими студентами курса</li>
          </ul>
        </div>
      </div>
      <Modal
        open={showModal}
        onClose={() => {
          setShowModal(false);
        }}
        maxWidth={'md'}
      >
        <div style={{width:"100%", padding:"30px"}}>
          <div style={{position:"relative",paddingTop:"56.25%"}}>
            <iframe
              title={'Обзор платформы'}
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%"
              }}
              allow="autoplay; encrypted-media"
              src="https://65395.servicecdn.ru/videos/65395_ZueVwZZxFOCp9Sfp"
              allowFullScreen
            />
          </div>
        </div>
      </Modal>
    </section>
  );
};
